import { Component } from "@angular/core";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { FormControl, FormGroup } from '@angular/forms';
  
@Component({
  selector: "date-editor",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"]
})
export class DatePicker implements ICellEditorAngularComp {
  public value!: Date; // will hold current date value
  formgroup = new FormGroup({
    changeDate: new FormControl()
  })

  agInit(params: any): void {
    this.value = params.value;
  }

  getValue() {
    // if user has chosen a date, send date to update
    if(this.formgroup.get('changeDate')!.value != null){
      return this.formgroup.get('changeDate')!.value
    }
    // if user hasn't chosen a date, send current date value
    else{
      return this.value;
    }
  }

  isPopup(): boolean {
    return true;
  }
}
